import { useRecentlyViewed } from "@/hooks/useRecentlyViewed";
import ProductCard from "./ProductCard";
import { Button } from "./ui/button";
import { X } from "lucide-react";

const RecentlyViewed = () => {
  const { recentlyViewed, clearRecentlyViewed } = useRecentlyViewed();

  if (recentlyViewed.length === 0) {
    return null;
  }

  return (
    <section className="py-4 md:py-6">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-lg md:text-xl font-bold">Recently Viewed</h2>
        <Button
          variant="ghost"
          size="sm"
          onClick={clearRecentlyViewed}
          className="text-muted-foreground hover:text-foreground h-8 text-xs"
        >
          <X className="h-3 w-3 mr-1" />
          Clear All
        </Button>
      </div>
      <div className="product-row-scroller flex snap-x snap-mandatory gap-2 overflow-x-auto pb-2 md:grid md:grid-cols-3 md:overflow-visible lg:grid-cols-6 md:gap-3">
        {recentlyViewed.map((product) => (
          <div key={product.id} className="w-36 shrink-0 snap-start md:w-auto">
            <ProductCard {...product} size="compact" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default RecentlyViewed;
